import { useState } from 'react';
import DomainValidatorsManager from '../Components/SuperAdmin/Validations/domain-validators-manager';
import ValidationRulesManager from '../Components/SuperAdmin/Validations/validation-rules-manager';
import Layout from '../Components/Shared/Layout';
import '../Components/SuperAdmin/Validations/globals.css'


const ValidationManagementPage = () => {
  const [activeTab, setActiveTab] = useState('validators');

  return (
    <Layout>
      <div className="content-body default-height">
        <div className="container-fluid">
          <div className="row">
            <div>
              <div className="col-xl-12">
                <div className="kanban-header">
                    <div className="left-title">
                        <div>
                          <h4
                            className="fw-bold text-primary fs-4 text-uppercase m-0"
                            style={{
                              letterSpacing: "1px",
                              textShadow: "1px 1px 2px rgba(0, 0, 0, 0.2)"
                            }}
                            >
                              Gestion de la Validation
                              <p className="text-muted">
                                Configurez les validateurs et les règles de validation pour chaque domaine et entité.
                              </p>
                          </h4>
                        </div>  
                    </div>
                    <div className="right-title">
                        <div className="title-content">
                            {/* <button
                              className="btn btn-sm btn-outline-primary ms-3"
                              onClick={onRefresh}
                              title="Rafraîchir"
                            >Rafraichir</button>    */}
                        </div>
                    </div>	
                </div>
              </div>  
            </div>

            {/* Navigation par onglets */}
            <ul className="nav nav-tabs mb-4 mt-4">
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'validators' ? 'active' : ''}`}
                  onClick={() => setActiveTab('validators')}
                >
                  Gestion des Validateurs
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'rules' ? 'active' : ''}`}
                  onClick={() => setActiveTab('rules')}
                >
                  Règles de Validation
                </button>
              </li>
            </ul>

            {/* Contenu des onglets */}
            <div className="tab-content">
              <div className={`tab-pane fade ${activeTab === 'validators' ? 'show active' : ''}`}>
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0 fs-3">Validateurs par Domaine</h5>
                    <p className="card-text text-muted">
                      Ajoutez ou retirez des utilisateurs comme validateurs pour un domaine spécifique.
                    </p>
                  </div>
                  <div className="card-body">
                    <DomainValidatorsManager />
                  </div>
                </div>
              </div>

              <div className={`tab-pane fade ${activeTab === 'rules' ? 'show active' : ''}`}>
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0 fs-3">Règles de Validation</h5>
                    <p className="card-text text-muted">
                      Configurez les règles de validation (Any, All, Quorum) pour chaque type d entité par domaine.
                    </p>
                  </div>
                  <div className="card-body">
                    <ValidationRulesManager />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ValidationManagementPage;